import { render, staticRenderFns } from "./BookingSpace.vue?vue&type=template&id=1f8666d7&scoped=true&"
import script from "./BookingSpace.vue?vue&type=script&lang=js&"
export * from "./BookingSpace.vue?vue&type=script&lang=js&"
import style0 from "./BookingSpace.vue?vue&type=style&index=0&id=1f8666d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8666d7",
  null
  
)

export default component.exports